import { Component, inject, signal, computed, effect, OnInit } from '@angular/core';
import { PatientService } from 'src/app/calvin-emr-shared/services/patient.service';
import { ContainersService } from 'src/app/knightmeds/services/containers.service';
import { tryResolveKnightmedsInstanceId } from 'src/environments/runtime-config';
import { PageComponent } from 'src/app/calvin-emr-shared/page/page.component';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { ProgressBar } from 'primeng/progressbar';
import { DataView } from 'primeng/dataview';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

/** A page to choose the patient to release medications for */
@Component({
  selector: 'app-patients-page',
  templateUrl: './patients-page.component.html',
  styleUrls: ['./patients-page.component.scss'],
  standalone: true,
  imports: [
    ProgressBar,
    DataView,
    RouterLink,
    ButtonModule,
    IconField,
    InputIcon,
    InputTextModule,
  ]
})
export class PatientsPageComponent extends PageComponent implements OnInit {
  /** All patients for the current user */
  private patientsSignal = signal<Patient[]>([]);
  readonly patients = computed(() => this.patientsSignal());

  /** Whether all necessary data has loaded */
  private loadedSignal = signal(false);
  readonly loaded = computed(() => this.loadedSignal());

  readonly isDeviceConnected = signal(false);

  /** Label for the "connect relay device" button -- names this laptop's own cabinet when known */
  private readonly knightmedsInstanceId = tryResolveKnightmedsInstanceId();
  readonly connectDeviceLabel = this.knightmedsInstanceId
    ? `Connect to ${this.knightmedsInstanceId}`
    : 'Connect Relay Device';

  private patientService = inject(PatientService);
  private containersService = inject(ContainersService);

  async ngOnInit(): Promise<void> {
    const connected = await this.containersService.tryAutoConnect();
    this.isDeviceConnected.set(connected);
  }

  async connectDevice(): Promise<void> {
    await this.containersService.connectDevice();
    this.isDeviceConnected.set(this.containersService.isDeviceConnected);
  }

  constructor() {
    super();
    effect(() => {
      const user = this.authStore.user();
      if (!user) return;
      this.patientService.getPatientsForUser(user).subscribe(patients => {
        this.patientsSignal.set(patients);
        this.loadedSignal.set(true);
      });
    });
  }
}
